module.exports = "/assets/8a748c5f6fba44c3b997e43b303adb88.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/DC.png
// module id = 1296
// module chunks = 0